import * as React from 'react';
import { DateTime, Validation, ValidationProps } from 'ui';
import { TimePicker } from 'ui/date-time/time/time';
import { ScheduleFieldKeys, TIME_MIDNIGHT_STRING } from 'app/area/company-report/constants';
import { ScheduleDefinition } from 'app/area/company-report/types-store';
import { createFormatters, createUTCDate, dateToUTC, parseAsDateUTC } from 'app/infrastructure/data/date';
import { toUTCDateWithLocalOffset, newDateOrUndefined } from './schedule-helpers';
import styles from './report-screen.scss';

interface ScheduleExecutionTimeProps {
  scheduleDefinition: ScheduleDefinition;
  onChangeExecutionTime: (val: Date) => void;
  onChangeRangeStartDay: (val: Date) => void;
  locale: string;
  getValidationErrors: (key: string) => ValidationProps;
  translations: { execution_time: string; start: string; done: string; empty_date_error: string };
}

export const ScheduleExecutionTime = ({
  scheduleDefinition, onChangeExecutionTime, onChangeRangeStartDay, locale, getValidationErrors,
  translations: { execution_time, start, done, empty_date_error }
}: ScheduleExecutionTimeProps) => {

  const selectedExecutionTime = toUTCDateWithLocalOffset(newDateOrUndefined(scheduleDefinition?.recurRangeStart));
  const selectedScheduleStartDate = toUTCDateWithLocalOffset(newDateOrUndefined(scheduleDefinition?.recurRangeStart));
  const executionTimeValidation = getValidationErrors(ScheduleFieldKeys.executionTime);

  return <div className={`${styles.scheduleRow}`}>
    <div className={styles.textWrapper}>
      <span className={styles.texts}>{execution_time}</span>
    </div>
    <div className="col-sm-6 col-md-4">
      <TimePicker
        locale={locale}
        componentId={ScheduleFieldKeys.executionTime}
        className="dateTime"
        value={selectedExecutionTime}
        onChange={onChangeExecutionTime}
        parseDate={parseAsDateUTC}
        {...createFormatters(locale)}
        createDate={createUTCDate}
        cloneDate={dateToUTC}
        labelConfirmTimeSelection={done}
        defaultValue={TIME_MIDNIGHT_STRING}
        textEmptyDateError={empty_date_error}
      />
      {executionTimeValidation && <Validation {...executionTimeValidation} />}
    </div>
    <div className={styles.textWrapper}>
      <span className={styles.texts}>{start}</span>
    </div>
    <div className="col-sm-6 col-md-4">
      <DateTime
        locale={locale}
        componentId={ScheduleFieldKeys.recurRangeStart}
        className={`dateTime ${styles.scheduleDateTime}`}
        value={selectedScheduleStartDate}
        onChange={onChangeRangeStartDay}
        parseDate={parseAsDateUTC}
        {...createFormatters(locale)}
        createDate={createUTCDate}
        cloneDate={dateToUTC}
        captionWrapper={'form'}
        validation={getValidationErrors(ScheduleFieldKeys.recurRangeStart)}
      />
    </div>
  </div>;
};
